import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import {
  hideFieldIf,
  createInitialValues,
  createFormValidationFn,
} from 'client/helpers/formikHelpers';

import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREEN,
} from 'client/components/SrButton/SrButton';
import SrModalV2, {
  MODAL_THEME_STACK,
} from 'client/components/SrModalV2/SrModalV2';
import SrFormikField, {
  SR_FIELD_THEME_ADOBE,
} from 'client/components/SrFormikField';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import { SR_CHECKBOX_THEME_BOX } from 'client/components/Checkbox';

const getFormFields = ({ values = {} } = {}) => [
  {
    id: 'installationMarkedAsCompleted',
    type: 'yes_no',
    validations: ['required'],
    className: 'yesnoFullWidth',
  },
  hideFieldIf(
    !values.installationMarkedAsCompleted,
    {
      id: 'markedInstallMissingItems',
      title: 'Were any items not installed?',
      type: 'multiple_choice',
      validations: ['required'],
      properties: {
        choices: [
          {
            label: 'CodeBox',
            value: 'CodeBox',
          },
          {
            label: 'Yard Sign',
            value: 'Yard Sign',
          },
        ],
        fieldType: SR_CHECKBOX_THEME_BOX,
        autoFitWidth: '343px',
      },
    },
  ),
];

const SrMarkInstallationAsCompletedModal = ({
  onClose,
  onSubmit,
}) => {
  return (
    <SrModalV2
      closeOnBackgroundClick
      onClose={onClose}
      showCloseButton={false}
      contentMaxWidth='375px'
      contentPadding='64px 16px 32px'
      theme={MODAL_THEME_STACK}
      contentHeight='598px'
    >
      <SrFlex direction='col' height='100%'>
        <SrFlex justify='center'>
          <SrText
            color='blueGreycliff'
            font='greycliff'
            fontSize='26px'
            lineHeight='33px'
            weight='800'
            align='center'
            block='block'
          >
            Are you sure you want to manually mark that the install was completed?
          </SrText>
        </SrFlex>
        <Formik
          initialValues={createInitialValues({
            formFields: getFormFields(),
            defaultValues: {
              installationMarkedAsCompleted: undefined,
              markedInstallMissingItems: [],
            },
          })}
          onSubmit={onSubmit}
          validate={(formValues) => {
            const formFields = getFormFields({ values: formValues });
            return createFormValidationFn(formFields)(formValues);
          }}
          render={(formikBag) => {
            const formFields = getFormFields({
              values: formikBag.values,
            });

            return (
              <SrFlex width='100%' height='calc(100% - 66px)'>
                <Form style={{ width: '100%', height: '100%' }}>
                  <SrFlex width='100%' height='100%' direction='col'>
                    {formFields.map((formField) => (
                      <SrBox key={formField.id} margin='10px 0'>
                        <SrFormikField
                          formField={formField}
                          formikBag={formikBag}
                          theme={SR_FIELD_THEME_ADOBE}
                          className={formField.className}
                        />
                      </SrBox>
                    ))}
                    <SrFlex marginTop='auto'>
                      <SrButton
                        theme={SR_BUTTON_THEME_ADOBE_GREEN}
                        type='submit'
                        disabled={!formikBag.isValid}
                      >
                        Save
                      </SrButton>
                    </SrFlex>
                  </SrFlex>
                </Form>
              </SrFlex>
            );
          }}
        />
      </SrFlex>
    </SrModalV2>
  );
};

SrMarkInstallationAsCompletedModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

SrMarkInstallationAsCompletedModal.displayName = 'SrMarkInstallationAsCompletedModal';

export default SrMarkInstallationAsCompletedModal;
